// Approved facts override legacy concept copy; translations contain no runtime logic.
import { getWorkflowOffer } from './workflow-offer';
import { approvedCopyEn } from './approved-copy.en';
import { approvedCopyEs } from './approved-copy.es';

const COPY = { en: approvedCopyEn, es: approvedCopyEs };
const NAV_PATHS = ['/how-it-works', '/pricing', '/faq', '/marketing'];

function pricingContent(base, copy) {
  return { ...base, title: copy.pricing.title, subtitle: copy.pricing.subtitle,
    plans: base.plans.map((plan, index) => ({ ...plan, desc: copy.planDescriptions[index],
      features: copy.planFeatures, price: copy.pricing.price, period: '', badge: copy.pricing.badge })) };
}

function demoInterface(base, offer, copy, points) {
  return { ...base, formTitle: offer.requestTitle, formSubtitle: offer.requestSubtitle,
    submit: offer.requestButton, disclaimer: offer.consentNote,
    labels: { ...base.labels, ...copy.demoLabels }, successText: copy.demoSuccess,
    toastSuccess: copy.demoToast, whatItems: points };
}

function legalContent(base, copy) {
  const sections = base.terms.sections.map((section, index) => {
    if (!Object.hasOwn(copy.termsBodies, index)) return section;
    return { ...section, body: copy.termsBodies[index] };
  });
  return { ...base, privacy: { ...base.privacy, updated: copy.privacyUpdated, sections: copy.privacySections },
    terms: { ...base.terms, sections } };
}

export function approvedContent(base, lang) {
  const copy = COPY[lang] || COPY.en;
  const offer = getWorkflowOffer(lang), points = offer.agenda.map(step => step.title);
  return { ...base, OFFER: offer,
    NAV_LINKS: NAV_PATHS.map(path => base.NAV_LINKS.find(link => link.path === path)).filter(Boolean),
    PRICING: pricingContent(base.PRICING, copy),
    FAQS: { ...base.FAQS, title: copy.faqTitle, items: copy.facts.map(([q, a]) => ({ q, a })) },
    DEMO: { ...base.DEMO, eyebrow: copy.demoEyebrow, title: offer.cta, subtitle: offer.demoSubtitle, points },
    UI: { ...base.UI, nav: { ...base.UI.nav, bookDemo: offer.navCta }, pricing: { note: copy.pricing.note },
      demo: demoInterface(base.UI.demo, offer, copy, points) },
    LEGAL: legalContent(base.LEGAL, copy) };
}